module.exports = __webpack_public_path__ + "img/Flag_of_Austria.78ef3ba4.svg";